import _ from 'lodash';
import { defineComponent } from 'vue';
import DefaultComponent from '@/components/schreg-default/DefaultComponent.vue';
// Components
import EventDetailsComponent from '@/components/schreg-eventDetails/EventDetailsComponent.vue';
import MyReservationsComponent from '@/components/schreg-myReservations/MyReservationsComponent.vue';
import MyReservationsBriefComponent from '@/components/schreg-myReservationsBrief/MyReservationsBriefComponent.vue';
import ReservationComponent from '@/components/schreg-reservation/ReservationComponent.vue';
import SavedSearchesBriefComponent from '@/components/schreg-savedSearchesBrief/SavedSearchesBriefComponent.vue';
import BookingComponent from '@/components/schreg-booking/BookingComponent.vue';
import ResourceBookingComponent from '@/components/schreg-resourceBooking/ResourceBookingComponent.vue';
import TrainerListComponent from '@/components/schreg-trainerList/TrainerListComponent.vue';
import ClassSchedulesComponent from '@/components/schreg-classSchedules/ClassSchedulesComponent.vue';
import ClassSchedulesBriefComponent from '@/components/schreg-classSchedulesBrief/ClassSchedulesBriefComponent.vue';
import EventsComponent from '@/components/schreg-events/EventsComponent.vue';
import EventsBriefComponent from '@/components/schreg-eventsBrief/EventsBriefComponent.vue';
// Sub-Components
import FormTestComponent from '@/components/schreg-default/FormTestComponent.vue';
import ModalTestComponent from '@/components/schreg-default/ModalTestComponent.vue';
import LiveDataWidgetComponent from '@/components/schreg-default/LiveDataWidgetComponent.vue';
import MultiselectTestComponent from '@/components/schreg-default/MultiselectTestComponent.vue';
import DatePickerTestComponent from '@/components/schreg-default/DatePickerTestComponent.vue';

// APIs
import EdgeApiTestComponent from '@/components/schreg-default/EdgeApiTestComponent.vue';

import { Helpers } from '@/common/helpers';

const schregComponentData = [
	DefaultComponent,
	EventDetailsComponent,
	MyReservationsComponent,
	MyReservationsBriefComponent,
	ReservationComponent,
	SavedSearchesBriefComponent,
	BookingComponent,
	ResourceBookingComponent,
	TrainerListComponent,
	ClassSchedulesComponent,
	ClassSchedulesBriefComponent,
	EventsComponent,
	EventsBriefComponent,
	FormTestComponent,
	ModalTestComponent,
	EdgeApiTestComponent,
	LiveDataWidgetComponent,
	MultiselectTestComponent,
	DatePickerTestComponent
];

export const SchregComponents = {
	findKeyByPath() {
		const pathArray = window.location.pathname.toLowerCase().split('/');
		const pathSegmentToCheck = pathArray[pathArray.length - 1].split('.')[0];
		let idx = _.findIndex(schregComponentData, function(o) {
			return pathSegmentToCheck.endsWith(o.config.devPath);
		});
		if (idx < 0) idx = 0;
		return schregComponentData[idx].config.key;
	},
	findComponentByKey(key: string) {
		let idx = _.findIndex(schregComponentData, function(o) {
			return o.config.key === key;
		});
		if (idx < 0) idx = 0;
		// prevent non-exported components from being loaded outside of development
		if (!Helpers.isDevOrUi() && !schregComponentData[idx].config.exported) {
			return undefined;
		}
		return schregComponentData[idx];
	},
	keyIsValid(key: string) {
		if (key === '') return true;
		const idx = _.findIndex(schregComponentData, function(o) {
			return o.config.key === key;
		});
		return idx > -1;
	}
};

export default defineComponent({
	functional: true,
	props: {
		page: {
			type: String,
			required: true,
			validator: (value: string) => {
				return SchregComponents.keyIsValid(value);
			}
		}
	},
	render: function(createElement, context) {
		return createElement(
			SchregComponents.findComponentByKey(context.props.page),
			context.data,
			context.children
		);
	}
});
